import { useState } from "react";
import { Mail, Send, Loader2, CheckCircle2 } from "lucide-react";
import { subscribeNewsletter } from "../../services/api";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError("");
    try {
      await subscribeNewsletter(email);
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 3500);
    } catch (err) {
      setStatus("error");
      setError(err.response?.data?.detail || "Please try again");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <div className="relative">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-orange-300" />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => { setEmail(e.target.value); setStatus("idle"); }}
          placeholder="Your email address"
          className="w-full pl-9 pr-24 py-2.5 rounded-full bg-white/10 border border-white/20 text-sm text-white placeholder:text-stone-400 focus:outline-none focus:border-orange-400"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="absolute right-1 top-1 bottom-1 px-4 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs font-bold hover:from-orange-600 hover:to-amber-600 disabled:opacity-60 flex items-center gap-1"
        >
          {status === "loading" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : status === "success" ? <CheckCircle2 className="w-3.5 h-3.5" /> : <Send className="w-3.5 h-3.5" />}
          {status === "success" ? "Subscribed" : "Join"}
        </button>
      </div>
      {status === "error" && <p className="text-xs text-red-400">{error}</p>}
      {status === "success" && <p className="text-xs text-green-400">Thank you for subscribing!</p>}
    </form>
  );
};

export default NewsletterForm;
